import React, { useState, useEffect, lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./Screens/Home/Home";
import "react-calendar/dist/Calendar.css";

import "./App.css";
import "./Variables.css";
import { ToastContainer } from "react-toastify";
import PopupContextProvider from "./Context/PopupContext";
import AppRouterPopups from "./AppRouterPopups";
import Services from "./Screens/Services/Services";
import { LoadScript } from "@react-google-maps/api";
import { useDispatch } from "react-redux";
import { setUserLocation } from "./Redux/Action";
import { Loader } from "./Components/Loader";

const Navbar = lazy(() => import("./Components/Navbar/Navbar"));
const Footer = lazy(() => import("./Components/Footer/Footer"));
const Login = lazy(() => import("./Screens/Login/Login"));
const SignUp = lazy(() => import("./Screens/SignUp/SignUp"));
const Otp = lazy(() => import("./Screens/OTP/Otp"));
const BookingDetail = lazy(() =>
  import("./Screens/BookingDetail/BookingDetail")
);
const BookAppointment = lazy(() =>
  import("./Screens/BookAppointment/BookAppointment")
);
const BookAppointmentDate = lazy(() =>
  import("./Screens/BookAppointmentDate/BookAppointmentDate")
);
const EmployeeDetail = lazy(() =>
  import("./Screens/EmployeeDetail/EmployeeDetail")
);
const EmployAbout = lazy(() => import("./Screens/EmployAbout/EmployAbout"));
const AppointmentCart = lazy(() =>
  import("./Screens/AppointmentCart/AppointmentCart")
);
const BillingSummary = lazy(() =>
  import("./Screens/BillingSummary/BillingSummary")
);
const GiveReview = lazy(() => import("./Screens/GiveReview/GiveReview"));
const EditProfile = lazy(() => import("./Screens/EditProfile/EditProfile"));
const About = lazy(() => import("./Screens/AboutUs/AboutUs"));
const ContactUs = lazy(() => import("./Screens/ContactUs/ContactUs"));
const Notifications = lazy(() =>
  import("./Screens/Notifications/Notifications")
);
const PrivacyPolicy = lazy(() =>
  import("./Screens/PrivacyPolicy/PrivacyPolicy")
);
const BookAppointmentScheduleDate = lazy(() =>
  import("./Screens/BookAppointmentScheduleDate/BookAppointmentScheduleDate")
);

// import BookAppointmentScheduleDate from "./Screens/BookAppointmentScheduleDate/BookAppointmentScheduleDate";
// import Navbar from "./Components/Navbar/Navbar";
// import Login from "./Screens/Login/Login";
// import SignUp from "./Screens/SignUp/SignUp";
// import Otp from "./Screens/OTP/Otp";
// import BookingDetail from "./Screens/BookingDetail/BookingDetail";
// import BookAppointment from "./Screens/BookAppointment/BookAppointment";
// import BookAppointmentDate from "./Screens/BookAppointmentDate/BookAppointmentDate";

// import EmployeeDetail from "./Screens/EmployeeDetail/EmployeeDetail";
// import EmployAbout from "./Screens/EmployAbout/EmployAbout";
// import AppointmentCart from "./Screens/AppointmentCart/AppointmentCart";
// import BillingSummary from "./Screens/BillingSummary/BillingSummary";
// import GiveReview from "./Screens/GiveReview/GiveReview";
// import EditProfile from "./Screens/EditProfile/EditProfile";
// import About from "./Screens/AboutUs/AboutUs";
// import ContactUs from "./Screens/ContactUs/ContactUs";
// import Notifications from "./Screens/Notifications/Notifications";
// import PrivacyPolicy from "./Screens/PrivacyPolicy/PrivacyPolicy";

const App = (props) => {
  const dispatch = useDispatch();
  const [isModalOpen, setIsModalOpen] = useState(true);
  const [userProfileImage, setUserProfileImage] = useState(
    localStorage.getItem("customerProfile")
      ? localStorage.getItem("customerProfile") == "null"
        ? null
        : localStorage.getItem("customerProfile")
      : ""
  );

  const data = [
    {
      id: 1,
    },
    {
      id: 2,
    },
    {
      id: 3,
    },
    {
      id: 4,
    },
    {
      id: 5,
    },
  ];

  var options = {
    enableHighAccuracy: true,
    timeout: 5000,
    maximumAge: 0,
  };

  function success(pos) {
    var crd = pos.coords;
    let location = {
      lat: crd.latitude,
      lng: crd.longitude,
    };

    dispatch(setUserLocation(location));
    console.log("Your current position is:");
    console.log(`Latitude : ${crd.latitude}`);
    console.log(`Longitude: ${crd.longitude}`);
    console.log(`More or less ${crd.accuracy} meters.`);
  }

  function errors(err) {
    console.warn(`ERROR(${err.code}): ${err.message}`);
  }

  useEffect(() => {
    if (navigator.geolocation) {
      navigator.permissions
        .query({ name: "geolocation" })
        .then(function (result) {
          console.log(result);
          if (result.state === "granted") {
            //If granted then you can directly call your function here
            navigator.geolocation.getCurrentPosition(success, errors, options);
          } else if (result.state === "prompt") {
            //If prompt then the user will be asked to give permission
            navigator.geolocation.getCurrentPosition(success, errors, options);
          } else if (result.state === "denied") {
            localStorage.setItem("lat", 21.3891);
            localStorage.setItem("lng", 39.8579);
            //If denied then you have to show instructions to enable location
          }
        });
    } else {
      console.log("Geolocation is not supported by this browser.");
    }
  }, []);

  return (
    <>
      <PopupContextProvider>
        <Suspense fallback={<Loader />}>
          {/* <LoadScript
            id="google-map-script-loader"
            googleMapsApiKey={"AIzaSyAGpL9qLO2D5V6ToKYEvAQZ7YymBRmB9Pk"}
            libraries={["places"]}
            loadingElement={<></>}
          > */}
          <BrowserRouter>
            {/* {!isBranchSelectedFromPopUp ? <PopUpModal /> : null} */}
            <Navbar userProfileImage={userProfileImage} />
            <Routes>
              <Route path="/home" element={<Home />} />
              <Route path="/" element={<Services />} />
              <Route path="/login" element={<Login />} />
              <Route path="/signup" element={<SignUp />} />
              <Route
                path="/otp"
                element={<Otp setUserProfileImage={setUserProfileImage} />}
              />
              <Route path="/bookingdetail" element={<BookingDetail />} />
              <Route path="/bookappointment" element={<BookAppointment />} />
              <Route
                path="/bookappointmentdate"
                element={<BookAppointmentDate />}
              />
              <Route
                path="/bookAppointmentscheduledate"
                element={<BookAppointmentScheduleDate />}
              />
              <Route path="/employeedetail" element={<EmployeeDetail />} />
              <Route path="/EmployAbout" element={<EmployAbout />} />
              <Route path="/appointmentcart" element={<AppointmentCart />} />
              <Route path="/billingsummary" element={<BillingSummary />} />
              <Route path="/GiveReview" element={<GiveReview />} />
              <Route path="/Notifications" element={<Notifications />} />
              <Route
                path="/Edit_Profile"
                element={
                  <EditProfile
                    userProfileImage={userProfileImage}
                    setUserProfileImage={setUserProfileImage}
                  />
                }
              />
              <Route path="/About_Us" element={<About />} />
              <Route path="/Contact_Us" element={<ContactUs />} />
              <Route path="/Privacy_Policy" element={<PrivacyPolicy />} />
            </Routes>
            <Footer />
            <AppRouterPopups />
            <ToastContainer style={{ fontSize: "14px" }} />
          </BrowserRouter>
          {/* </LoadScript> */}
        </Suspense>
      </PopupContextProvider>
    </>
  );
};

export default App;
